require('slick.js/slick/slick.min')

$ ->
  $('.slider').slick
    arrows: false
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'linear'
    dots: true
    fade: true
    lazyLoad: 'ondemand'
    infinite: true
    speed: 500
    useTransform: false

  $('li', '.product-gallery ul').click (e) ->
    e.preventDefault()
    slideIndex = $(this).index()
    $('li', '.product-gallery ul').removeClass 'act'
    $(this).addClass 'act'
    $('.product-gallery__items').slick('slickGoTo', slideIndex, false)
    return

  $('.product-gallery__items').on 'beforeChange', (event, slick, currentSlide, nextSlide) ->
    navItem = $('li', '.product-gallery ul').get(nextSlide)
    $('li', '.product-gallery ul').removeClass 'act'
    $(navItem).addClass 'act'
    return



// WEBPACK FOOTER //
// ./Components/slick.coffee